import * as React from "react"
import { motion } from "motion/react"

interface AdminCardProps {
  children: React.ReactNode
  className?: string
  delay?: number
}

export function AdminCard({ children, className = "", delay = 0 }: AdminCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay, ease: [0.25, 0.46, 0.45, 0.94] }}
      className={`bg-[#111117] border border-[#1E1E2A] rounded-xl p-5 ${className}`}
    >
      {children}
    </motion.div>
  )
}
